const upperText = (text) => {
  return text.toUpperCase()
}

export default upperText
